const photoEnhancer = {
  UnlimitedNumberOfSheets: '무제한 제출',
  SupportAllModels: '모든 모델 지원',
  MagnificationAllX: '배율 : 1x, 2x, 4x, 8x',
  OutputImageFormatMore: '출력 이미지 형식 : JPG, PNG, TIFF',
  NoWatermark: '워터 마크 없음',
  CancelAtAnytime: '언제든지 취소 가능',
  HighPriorityProcessingSpeed: '고속 우선 처리 기술',
  HitPawAIPhotoEnhancer: 'HitPaw AI Photo Enhancer',
  weekDayPrice: '₩1,643',
  WeekTotalPrice: '₩1,1499',
  MonthDayPrice: '₩810',
  MonthTotalPrice: '₩24,299',
  YearDayPrice: '₩454',
  YearTotalPrice: '₩165,799',
  Day: '일',
  Monthly: '월',
  Weekly: '주',
  Yearly: '년',
};

export default photoEnhancer;
